// extracted by mini-css-extract-plugin
export default {"Image":"style_Image__BqFUt"};